import { fetchQuery, FetchQueryFetchPolicy } from "relay-runtime"
import { chPatientByIdQuery } from "@/modules/patients/services/ch/__generated__/chPatientByIdQuery.graphql"
import { ch_PatientByIdQuery } from "@/modules/patients/services/ch/chPatientByIdQuery"
import { RelayEnvironment } from "@/relay-environment"

export const fetchChPatient = (
  input: chPatientByIdQuery["variables"],
  next?: (data: chPatientByIdQuery["response"]) => void,
  cacheConfig?: { fetchPolicy?: FetchQueryFetchPolicy },
) => {
  fetchQuery<chPatientByIdQuery>(RelayEnvironment, ch_PatientByIdQuery, input, cacheConfig).subscribe({ next })
}
